import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
} from 'reactstrap';

class RolePage extends React.Component {
  constructor(props) {
    super(props);
  }

  createRole = () => {
    this.props.history.push('/roles/create');
  };
  render() {
    return (
      <Page
        className="Rolepage"
        title="Role"
        breadcrumbs={[{ name: 'Role', active: true }]}
      >
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <div className="text-right mb-4">
                  <Button
                    className="theme-button theme-button-primary"
                    onClick={this.createRole}
                  >
                    Create
                  </Button>
                </div>
                <Table responsive hover className="ps-table tb-col-3">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Tags</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Larry</td>
                      <td>the Bird</td>
                      <td>
                        <div className="ps-action-button">
                          <Button className="theme-button theme-button-primary-light">
                            Details
                          </Button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}
export default RolePage;
